import React from 'react';
import WebhooksAccessLayout from '../../../components/WebhooksAccessLayout';
import { READ_WEBHOOK_EVENTS } from '../../../constants/webhookPermissions';

export default function DeliveryLogsAccessLayout() {
  return <WebhooksAccessLayout title="Logs" permission={READ_WEBHOOK_EVENTS} />;
}
